import React, { memo, useEffect, useState } from 'react';
import moment from 'moment';
import guaranteedIcon from '../../../assets/images/guaranteed-icon.svg';
import OnCallBadge from '../OnCallBadge';
import CompassIcon from '../../../components/icons/CompassIcon';
import BaseBadge from '../../../components/badges/BaseBadge';
import CustomNumberInput from '../../../components/CustomNumberInput/CustomNumberInput';

import './AddSlots.scss';

const SLOT_LIMIT = 20;

const AddSlots = ({ shift, showGuaranteed = false, numberOfSlots, setNumberOfSlots, isMobile }) => {
	const [duration, setDuration] = useState(null);
	const [shiftDate, setShiftDate] = useState(null);
	const [shiftDay, setShiftDay] = useState(null);

	useEffect(() => {
		// raw_start_time is shift.start_time AT TIME ZONE facility.timezone
		// on the server node-postgres calls new Date() on the date string returned by the postgres server
		// Because the local time zone of the server is UTC, the date string returned by postgres is then converted
		// to UTC at the hour returned by postgres. Timezone info is lost
		// calling just moment(...) here applies the local browser time zone
		// this means that depending on the time zone, you can either end up with
		// - a date on the previous day when local browser timezone is GMT -x
		// - a date on the next day when local timezone is GMT +x
		// using moment.utc prevents additional time conversions and fixes the issue
		const end = moment.utc(shift.raw_end_time);
		const start = moment.utc(shift.raw_start_time);
		setDuration(end.diff(start, 'hours', true));
		setShiftDate(start.format('MM/DD'));
		setShiftDay(start.format('ddd'));
	}, [shift]);

	const featureValue = (
		<>
			{showGuaranteed && (
				<span className="guaranteed-badge-span slot mb-2">
					<img className="guaranteed-icon" src={guaranteedIcon} alt="Guaranteed shift" />
					Guaranteed
				</span>
			)}
			{shift.is_orientation && (
				<BaseBadge badgeCopy="Orientation" className="orientation-badge" icon={<CompassIcon />} />
			)}
			{shift.isOnCall && <OnCallBadge />}
			{!shift.isOnCall && !shift.is_orientation && !showGuaranteed && '-'}
		</>
	);

	const fields = [
		{
			label: 'Professionals',
			value: (
				<CustomNumberInput
					className="provider-input"
					value={numberOfSlots}
					onChange={setNumberOfSlots}
					min={1}
					max={SLOT_LIMIT}
				/>
			)
		},
		{ label: 'Shift type', value: <div>{shift.slots[0].resource_type}</div> },
		{
			label: 'Date',
			value: (
				<div>
					<strong>{shiftDay}</strong> {shiftDate}
				</div>
			)
		},
		{
			label: 'Shift time',
			value: (
				<div>
					{shift.start_time} - {shift.end_time}
				</div>
			)
		},
		{ label: 'Hours', value: <div>{duration}</div> },
		{ label: 'Feature', value: featureValue }
	];

	return (
		<div className="add-slots">
			<p className="title-slots">
				Facility: <strong>{shift.facility_name}</strong>
			</p>
			{isMobile ? (
				<div className="add-slots-mobile">
					{fields.map((field) => (
						<div className="add-slot-field" key={field.label}>
							<span className="field-label">{field.label}</span>
							<div className="field-value">{field.value}</div>
						</div>
					))}
				</div>
			) : (
				<table className="table shifts-confirmation-table">
					<thead className="header-confirmation-shifts">
						<tr>
							{fields.map((field) => (
								<th className="head-text" key={field.label}>
									{field.label}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						<tr className="row-confirmation-shifts slots" key={`add-slot-details-${shift.id}`}>
							{fields.map((field) => (
								<td className="row-shift add-shift" key={field.label}>
									{field.value}
								</td>
							))}
						</tr>
					</tbody>
				</table>
			)}
		</div>
	);
};

export default memo(AddSlots);
